/**
 * 学员管理 API
 */
import http from './httpRequest.js'

/**
 * 获取学员统计概览
 */
export function getStudentStatistics() {
  return http({
    url: '/student/statistics',
    method: 'GET'
  })
}

/**
 * 创建学员
 */
export function createStudent(data) {
  return http({
    url: '/student/create',
    method: 'POST',
    data
  })
}

/**
 * 更新学员
 */
export function updateStudent(id, data) {
  return http({
    url: `/student/update/${id}`,
    method: 'PUT',
    data
  })
}

/**
 * 删除学员
 */
export function deleteStudent(id) {
  return http({
    url: `/student/delete/${id}`,
    method: 'DELETE'
  })
}

/**
 * 获取学员详情
 */
export function getStudentDetail(id) {
  return http({
    url: `/student/detail/${id}`,
    method: 'GET'
  })
}

/**
 * 获取学员列表
 */
export function getStudentList(params) {
  return http({
    url: '/student/list',
    method: 'GET',
    params
  })
}

/**
 * 分配教练和司机
 */
export function assignCoachAndDriver(data) {
  return http({
    url: '/student/assign',
    method: 'POST',
    data
  })
}

/**
 * 获取学员分配信息
 */
export function getStudentAssignment(studentId) {
  return http({
    url: `/student/assignment/${studentId}`,
    method: 'GET'
  })
}

/**
 * 上传缴费凭证
 */
export function uploadPaymentVoucher(data) {
  return http({
    url: '/student/payment/upload',
    method: 'POST',
    data
  })
}

/**
 * 审核缴费凭证
 */
export function auditPayment(id, status, remark) {
  return http({
    url: `/student/payment/audit/${id}`,
    method: 'PUT',
    params: { status, remark }
  })
}

/**
 * 获取缴费记录列表
 */
export function getPaymentList(params) {
  return http({
    url: '/student/payment/list',
    method: 'GET',
    params
  })
}

/**
 * 获取缴费统计
 */
export function getPaymentStatistics() {
  return http({
    url: '/student/payment/statistics',
    method: 'GET'
  })
}

/**
 * 锁定账单
 */
export function lockBill(id) {
  return http({
    url: `/student/payment/lock/${id}`,
    method: 'PUT'
  })
}

/**
 * 修改缴费记录
 */
export function updatePayment(id, data) {
  return http({
    url: `/student/payment/update/${id}`,
    method: 'PUT',
    data
  })
}

/**
 * 获取教练列表
 */
export function getCoachList(keyword) {
  return http({
    url: '/employee/coach/list',
    method: 'GET',
    params: { keyword }
  })
}

/**
 * 获取司机列表
 */
export function getDriverList(keyword) {
  return http({
    url: '/employee/driver/list',
    method: 'GET',
    params: { keyword }
  })
}

/**
 * 获取学员列表（用于创建任务时选择学员）
 */
export function getStudentSelectList(params) {
  return http({
    url: '/student/list',
    method: 'GET',
    params: { ...params, page: 1, pageSize: 1000 }
  })
}

/**
 * 修改培训记录
 */
export function updateTrainRecord(data) {
  return http({
    url: `/student/train-record/${data.id}`,
    method: 'PUT',
    data
  })
}
